import { render } from "./SupperPage.vue?vue&type=template&id=572d7bef&scoped=true"
import script from "./SupperPage.vue?vue&type=script&lang=js"
export * from "./SupperPage.vue?vue&type=script&lang=js"

import "./SupperPage.vue?vue&type=style&index=0&id=572d7bef&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-572d7bef"]])

export default __exports__